import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AcademyCommonModule, PipesModule } from '@draeger-academy/common';
import { AcademyPresentationUiModule, DaLinkModule } from '@draeger-academy/presentation';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { TranslateModule } from '@ngx-translate/core';
import { CountrySelectionComponent } from './country-selection.component';

const routes: Routes = [{ path: '', component: CountrySelectionComponent }];

@NgModule({
    declarations: [CountrySelectionComponent],
    imports: [CommonModule, AcademyCommonModule, PipesModule, AcademyPresentationUiModule, TranslateModule.forChild()],
    exports: [CountrySelectionComponent]
})
export class CountrySelectionModule {}
